export const formOptions = [
  {
    name: "photo_treatment",
    title: "Autorizo el tratamiento de mi fotografía",
    type: "accept",
    default: true,
  },
  {
    name: "health_status_treatment",
    title:
      "Autorizo el tratamiento de información relativa a mi estado de salud",
    type: "accept",
    default: true,
  },
  {
    name: "reporting_to_credit_bureaus",
    title: "Autorizo el reporte en centrales de riesgo",
    type: "accept",
    default: true,
  },
  {
    name: "footprint_usage",
    title: "Aurotizo el uso de mi huella",
    type: "accept",
    default: true,
  },
  {
    name: "sending_commercial_information",
    title: "Acepto recibir información relacionada con el bien y/o servicio adquirido",
    type: "accept",
    default: true,
  },
  {
    name: "commercial_information_by_email",
    title: "Email",
    type: "accept",
    default: true,
    contact:true
  },
  {
    name: "commercial_information_by_msm",
    title: "SMS",
    type: "accept",
    default: true
  },
  {
    name: "commercial_information_by_app",
    title: "Notificaciones APP BODYTECH",
    type: "accept",
    default: true
  },
  {
    name: "commercial_information_by_whatsapp",
    title: "Whatsapp",
    type: "accept",
    default: true
  },
  {
    name: "commercial_information_via_telephone",
    title: "Llamadas telefónicas",
    type: "accept",
    default: true
  },
  {
    name: "photo_treatment_represented",
    title: "Autorizo el tratamiento de la fotografía de mi representado(a)",
    type: "accept",
    default: true,
    under_age:true,
  },
  {
    name: "health_status_treatment_represented",
    title: "Autorizo el tratamiento de información relativa del estado de salud de mi representado(a)",
    type: "accept",
    default: true,
    under_age:true,
  },
  {
    name: "footprint_usage_treatment_represented",
    title: "Autorizo el uso de la huella de mi representado(a) ",
    type: "accept",
    default: true,
    under_age:true,
  },
  {
    name: "manage_public_resources",
    title:
      "¿Declaración de ingresos afiliado o representante legal del menor maneja recursos publicos?",
    type: "yes",
  },
  {
    name: "public_power_or_public_servant",
    title:
      "¿Ostenta algún grado de poder público o goza de reconocimiento publico o es servidor público?",
    type: "yes",
  },
  {
    name: "perform_nationals_operations",
    title: "¿Realiza operaciones internacionales?",
    type: "yes",
  },
  {
    name: "perform_imports",
    title: "¿Realiza importaciones?",
    type: "yes",
  },
  {
    name: "perform_exports",
    title: "¿Realiza exportaciones?",
    type: "yes",
  },
  {
    name: "make_investments_abroad",
    title: "¿Realiza inversiones en el exterior?",
    type: "yes",
  },
  {
    name: "make_loans_abroad",
    title: "¿Realiza prestamos en el exterior?",
    type: "yes",
  },
  {
    name: "make_or_receiving_money_orders",
    title: "¿Realiza envios o recepción de giros?",
    type: "yes",
  },
  {
    name: "make_transfers_abroad",
    title: "¿Realiza transferencias en el exterior?",
    type: "yes",
  },
  {
    name: "accept_minimum_permanence",
    title: "Acepto que  estoy comprando un plan con permanencia mínima de 12 meses, y en caso de retiro anticipado pagaré un recargo correspondiente a un porcentaje de los débitos faltantes para cumplir el año, conforme a la cláusula de permanencia mínima  que debo consultar",
    type: "accept",
    default: false,
    permanence:true,
    url:true,
    text_url:"aqui"
  }
];
